export enum ToastType {
  success = 'success',
  error = 'error',
  loading = 'loading',
  blank = 'blank',
  custom = 'custom',
}
